<style lang="scss" scoped>
  .credit-card-wrapper {
    margin: 15px 0;
  }

  .credit-card {
    margin-bottom: 15px;

    .form-group {
      margin-bottom: 3px !important;
    }

    label, input {
      font-size: 13px !important;
    }
  }

  @media (max-width: 450px) {
    .credit-card-wrapper {
      -webkit-transform: scale(0.85);
      -ms-transform: scale(0.85);
      transform: scale(0.85);
      margin: 0;
    }
  }
</style>

<template>
  <div class="credit-card">
    <div class="credit-card-wrapper" />

    <div class="form-group row py-1">
      <div class="col-12">
        <input
          type="text"
          v-model="cardForm.number"
          class="form-control"
          :placeholder="__('Número do cartão')"
          id="cc-number"
          data-stripe="number"
          required
        >
      </div>
    </div>

    <div class="form-group row py-1">
      <div class="col-12">
        <input
          type="text"
          v-model="cardForm.name"
          class="form-control"
          :placeholder="__('Nome impresso no cartão')"
          id="cc-name"
          data-stripe="name"
          required
        >
      </div>
    </div>

    <div class="form-group row py-1">
      <div class="col-6">
        <input
          type="text"
          v-model="cardForm.expiry"
          class="form-control"
          :placeholder="__('Data de Validade MM/AAAA')"
          id="cc-expiry"
          data-stripe="month"
          required
        >
      </div>
      <div class="col-6">
        <input
          type="text"
          v-model="cardForm.cvc"
          class="form-control"
          :placeholder="__('Código de Segurança')"
          id="cc-cvc"
          data-stripe="cvc"
          required
        >
      </div>
    </div>

    <div class="form-group text-center">
      <span
        class="form-text text-danger"
        v-show="cardForm.errors.has('number')"
      >
        {{ cardForm.errors.get('number') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],

  mounted () {
    this.$nextTick(() => {
      new Card(this.defaults);
    });

    Bus.$on('updateCreditCard', () => {
      this.updateValue();
    });
  },

  data () {
    return {
      cardForm: this.value,
      defaults: {
        form: '#payment-form',
        container: '.credit-card-wrapper',

        formSelectors: {
          numberInput: 'input#cc-number',
          expiryInput: 'input#cc-expiry',
          cvcInput: 'input#cc-cvc',
          nameInput: 'input#cc-name',
        },

        width: 300,
        formatting: true,

        messages: {
          validDate: this.__('validade'),
          monthYear: this.__('mês/ano'),
        },

        placeholders: {
          number: '•••• •••• •••• ••••',
          name: this.__('Nome Completo'),
          expiry: '••/••••',
          cvc: '•••',
        },

        // if true, will log helpful messages for setting up Card
        debug: true, // optional - default false
      },
    };
  },

  methods: {
    updateValue () {
      this.$emit('input', this.cardForm);
    },
  },
};
</script>
